import axios, {AxiosResponse} from 'axios';
import {IUserGroup, IUserProfile} from '@wholesalechange/chatcomponent';
import {ISiteSettingsDto} from '../auth/interfaces';

export const getUserProfileApi = (): Promise<AxiosResponse<IUserProfile>> => {
  return axios.get<IUserProfile>(`${process.env.REACT_APP_API_URL}/user/profile`);
};
export const updateUserProfileApi = (profile: IUserProfile): Promise<AxiosResponse<IUserProfile>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/user/profile/update`,
    profile
  );
};
export const updateUserProfileNicknameApi = (nickname: string): Promise<AxiosResponse<boolean>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/user/set/nick`,
    {nickname}
  );
};
export const getUserGroupsApi = (): Promise<AxiosResponse<IUserGroup[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/user/groups`
  );
};

export const getUserSiteSettingsApi = (): Promise<AxiosResponse<ISiteSettingsDto>> => {
  return axios.get<ISiteSettingsDto>(`${process.env.REACT_APP_API_URL}/user/settings`);
};

export const verifyEmail = (email: string): Promise<AxiosResponse<boolean>> => {
  return axios.get<boolean>(`${process.env.REACT_APP_API_URL}/user/verify/email`,
    {
      params: {
        email
      }
    });
};
export const updateUserVideoAvatarApi = (avatarId: number): Promise<AxiosResponse<IUserProfile>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/user/set/video/avatar`,
    avatarId
  );
};
